export default function Service3DPrint({ size = 96 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 96 96" fill="none" aria-hidden="true">
      {/* gantry / marco */}
      <path d="M18 20 H78" stroke="currentColor" strokeWidth="1.25" />
      <path d="M22 20 V70 M74 20 V70" stroke="currentColor" strokeWidth="1.25" />
      {/* carro + cabezal */}
      <rect x="40" y="24" width="16" height="10" stroke="currentColor" strokeWidth="1.25" />
      {/* filamento extruido (acento) */}
      <path d="M48 34 V41" stroke="#54B53C" strokeWidth="1.25" />
      {/* objeto impreso por capas */}
      <path
        d="M40 50 H56 M38 55 H58 M36 60 H60 M34 65 H62"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      {/* base / cama */}
      <path d="M28 70 H68" stroke="currentColor" strokeWidth="1.25" />
    </svg>
  );
}
